import { Component, OnInit } from '@angular/core';
import { UsuarioService } from '../../services/usuario.service';

@Component({
  selector: 'app-nopagefound',
  templateUrl: './nopagefound.component.html',
  styleUrls: ['./nopagefound.component.css']
})
export class NopagefoundComponent implements OnInit {
  fecha:number= new Date().getFullYear();

  constructor(private usuarioService: UsuarioService) {
  }

 ngOnInit(): void {
   this.usuarioService.getUsuario()
   .then()
   .catch(err=> console.log(err));
 }

}
